module.exports = __webpack_public_path__ + "static/img/02.378e654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour6/02.jpg
// module id = O166
// module chunks = 0